import { Component, ChangeDetectionStrategy } from '@angular/core';
import { GroupedNavigationLinks } from '../../../core/models/grouped-navigation-links';
import { environment } from '../../../../environments/environment';

const ewaWebsiteUrl = environment.ewaWebsiteUrl;

@Component({
    selector: 'app-footer',
    standalone: true,
    templateUrl: './footer.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './footer.component.scss',
})
export class FooterComponent {
    currentYear = new Date().getFullYear();

    navigationLinks: GroupedNavigationLinks[] = [
        {
            text: 'ABOUT',
            childLinks: [
                {
                    text: 'Mission & History',
                    url: 'https://www.enterprisewireless.org/mission-history',
                },
                {
                    text: 'Board of Directors',
                    url: `${ewaWebsiteUrl}/about/board-of-directors`,
                },
                {
                    text: 'Leadership Team',
                    url: 'https://www.enterprisewireless.org/leadership-team',
                },
                {
                    text: 'Critical Alliances',
                    url: 'https://www.enterprisewireless.org/critical-alliances',
                },
                {
                    text: 'Annual Report',
                    url: 'https://www.enterprisewireless.org/content/annual-reports',
                },
                {
                    text: 'Contact Your Spectrum Advisor',
                    url: 'https://www.enterprisewireless.org/contact',
                },
            ],
        },
        {
            text: 'MEMBERSHIP',
            childLinks: [
                {
                    text: 'Join Now!',
                    url: 'https://www.enterprisewireless.org/membership',
                },
                {
                    text: 'Member Benefits',
                    url: 'https://www.enterprisewireless.org/member-benefits',
                },
                {
                    text: 'EWA Connect',
                    url: 'https://connect.enterprisewireless.org/portal/custom?renderUrl=11',
                },
                {
                    text: 'Wireless Investment Model',
                    url: 'https://www.enterprisewireless.org/wireless-system-investment-model',
                },
            ],
        },
        {
            text: 'RESOURCES',
            childLinks: [
                {
                    text: 'Forms Library',
                    url: 'https://www.enterprisewireless.org/forms-library',
                },
                {
                    text: 'MBAN Registration',
                    url: 'https://www.mbanregistration.org/',
                },
                {
                    text: 'Service Fees',
                    url: 'https://www.enterprisewireless.org/service-fees',
                },
                {
                    text: 'Wireless Investment Model',
                    url: 'https://www.enterprisewireless.org/wireless-system-investment-model',
                },
            ],
        },
        {
            text: 'SERVICES',
            childLinks: [
                {
                    text: 'Spectrum Intel™',
                    url: `${ewaWebsiteUrl}/spectrumintel`,
                },
                {
                    text: 'Cevo®',
                    url: `${ewaWebsiteUrl}/cevo`,
                },
                {
                    text: 'Cevo Go®',
                    url: `${ewaWebsiteUrl}/cevogo`,
                },
                {
                    text: 'License Bank™',
                    url: 'https://www.enterprisewireless.org/services/license-bank',
                },
                {
                    text: 'License Management',
                    url: `${ewaWebsiteUrl}/services/license-management`,
                },
                {
                    text: 'EWA Connect',
                    url: 'https://connect.enterprisewireless.org/portal/custom?renderUrl=11',
                },
                {
                    text: 'Wireless Solutions Center',
                    url: 'https://www.wirelesssolutionscenter.com/',
                },
                {
                    text: 'MBAN Registration',
                    url: 'https://www.mbanregistration.org/',
                },
                {
                    text: 'Service Fees',
                    url: 'https://www.enterprisewireless.org/service-fees',
                },
            ],
        },
    ];
}
